// extracted by mini-css-extract-plugin
module.exports = {"content":"offsetContentStyle-module--content--21_Dl","message":"offsetContentStyle-module--message--2Cj1G"};